<template>
  <div style="max-width: 1400px">
    <div class="row ">
      <!--      <a class="btn btn-primary mybutton ml-auto" href="#" @click="queryItem(false)">查詢</a>-->
      <!--      <a class="btn btn-primary mybutton" href="javascript:location.reload()" >清除搜尋</a>-->
            <a class="btn btn-info mybutton " href="#" @click="addItem">新增</a>
            <a class="btn btn-danger mybutton" href="#" @click="deleteItem">刪除</a>
      <a class="btn btn-danger mybutton" @click.prevent="reset">回上一頁</a>
    </div>


    <div class="row">
      <a class="btn btn-info mybutton " href="#" @click="xlsImport">匯入報名資料 (只新增資料，不修改)</a>
      <a class="btn btn-info mybutton " href="#" @click="xlsImportTableNo">匯入桌號資料 (只修改資料，不新增)</a>
      <a class="btn btn-info mybutton " href="#" @click="xlsExport">匯出清單</a>
      <a class="btn btn-info mybutton " href="#" @click="xlsExportDetail">匯出(詳細)</a>
      <a class="btn btn-info mybutton " href="#" @click="eventItemSetting">報名場次修改(整批)</a>
      <a class="btn btn-info mybutton " href="#" @click="qrCodeGen">產生QRCode</a>

      <a class="btn btn-danger mybutton " href="#" @click="delAllMember">刪除全部報名資料</a>

    </div>
    <div class="row">
<!--      <a class="btn btn-info mybutton " href="#" @click="eventItemFilter">場次篩選</a>-->
      <a class="btn btn-info mybutton " @click="openGame">抽獎</a>
    </div>

    <div class="row">
      <!--      <a class="btn btn-info mybutton " href="#" @click="eventItemFilter">場次篩選</a>-->
      <input type="text" class="form-control" placeholder="" v-model="searchKeyword" style="max-width: 150px">
      <a class="btn btn-primary" href="#" @click="search"><i class="fa fa-search"></i> 查詢</a>
      <br>
    </div>
    <hr>

    <!--    style="width:1300px"-->
    <MyGridKendo ref="grid" :columns="gridDefine.columns" :datas="gridDefine.datas" ></MyGridKendo>

    <DLGEventItems ref="dlgEventItems" v-on:returnAdd="dlgEventItemsReturnAdd" v-on:returnRemove="dlgEventItemsReturnRemove"   v-on:returnSelect="dlgEventItemsReturnSelect" />

    <FileUploadAndProcess ref="fileUploadAndProcess" file-size-mega="30" v-on:uploadSuccess="uploadSuccess" />
    <FileUploadAndProcess ref="fileUploadAndProcessTableNo" file-size-mega="30" v-on:uploadSuccess="uploadSuccessTableNo" />

  </div>
</template>

<script>
import {
  QueryType_CheckIn_Index_2_EventMember,
    CheckIn_EventItemType_Open,
  CheckIn_EventItemType_NeedReg,
} from "../js/checkInDeclare";
import MyGridEasyTable from "@/views/taylorAdmin/component/MyGridEasyTable";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";
import util from "@/util/util";
import DLGEventItems from "@/views/checkInAdmin/Event/DLGEventItems";
import FileUploadAndProcess from "@/views/taylorAdmin/component/FileUploadAndProcess";
import MyGridKendo from "@/views/taylorAdmin/component/MyGridKendo";
/**

 **/
let editRouter="CheckInAdminEventMemberListMemberEdit";
let returnRoute="CheckInAdminEventMemberListIndex";

export default {
  components: {MyGridKendo, FileUploadAndProcess, DLGEventItems, MyGridEasyTable},
  //name: "Index",
  // props: [""],
  data: function () {
    return {
      QueryType_CheckIn_Index_2_EventMember:QueryType_CheckIn_Index_2_EventMember,
      CheckIn_EventItemType_Open:CheckIn_EventItemType_Open,
      CheckIn_EventItemType_NeedReg:CheckIn_EventItemType_NeedReg,
      type:"",
      SystemId:"",
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      eventJoinInfo:[],
      eventJoinInfoDemo:[
        {
          EventSystemId:"",
          IsJsoin:true,
        }
      ],

      gridDefine:{
        columns: [
          { field: 'fun', title: '功能' ,width:100, filterable:false, cell: this.cellFunctionLink},
          { field: "Id", title: "社員ID", width:100},
          { field: "Ename",  title: "Member Name", width:200},
          { field: "Area",  title: "分區", width:50},
          { field: "Name",  title: "姓名", width:100},
          { field: "Position",  title: "扶輪職稱", width:100},
          { field: "CallName", title: "Call name", width:100},
          { field: "Group", title: "所屬社", width:100},
          { field: "Tel", title: "行動電話", width:120},
          { field: "DisplayInfo", title: "參與場次", width:500},
          //other minWidth: 100,filterable:false
        ],
        datas:[],
      },
      searchKeyword:"",
     };
  },
  methods: {
    cellFunctionLink: function (h, tdElement , props, clickHandler ) {  // eslint-disable-line
      let that=this;
      let clickFun=function(){
        // that.gotoWithSystemId('MemberEdit',props.dataItem.SystemId)
        that.editItem(props.dataItem.SystemId);
      }

      //---------------------------------------
      return h('td', {
        on: {
          click: function(e){// eslint-disable-line
            clickFun();
          }
        },
        domProps: {
          innerHTML: '<a class="btn btn-primary" href="#" style="color:white"><i class="fa fa-pen"></i></a>'
        }
      });
    },
    async loadData() {
      // let data=await apiAdmin.getContentList(this.type);
      let data=await apiCheckIn.api_Member_Query(this.SystemId,this.searchKeyword);
      this.gridDefine.datas=apiAdmin.initReturnArray(data.data.data);
      this.$refs.grid.resetDatas();
    },
    addItem(){
      this.$router.push({ name: editRouter, query: { type: this.type,SystemId:"",EventSystemId:this.SystemId } })
    },
    editItem (SystemId) {// eslint-disable-line
      this.$router.push({ name: editRouter, query: { type: this.type,SystemId:SystemId ,EventSystemId:this.SystemId} });
    },
    deleteItem(){
      let ids=this.$refs.grid.selectedItemsSystemIds();

      if (ids.length>0){
        if (confirm('確定刪除?')){
          apiCheckIn.api_Member_Delete(ids).then(()=>{
            this.loadData();
          });
        }
      }else{
        util.ShowMessage('請先選擇欲刪除的資料');
      }
    },
    reset:function(){
      this.$router.push({ name: returnRoute, query: { type: this.type }})
    },
    xlsImport(){
      this.$refs.fileUploadAndProcess.popupFileUpload();
    },
    xlsImportTableNo(){
      this.$refs.fileUploadAndProcessTableNo.popupFileUpload();
    },
    xlsExport() {
      this.$refs.grid.exportExcel();
    },
    xlsExportDetail() {
      let loader=util.ShowLoading(this);

      apiCheckIn.api_CheckInExportExcel(this.SystemId).then((result)=>{
        this.loadData()
        util.HideLoading(loader);

        apiCheckIn.api_Download(result.data.data);

      });
    },
    eventItemSetting(){
      let arrResult=this.getSelectRowData();

      if (!arrResult){
        return;
      }

      this.$refs.dlgEventItems.Mode="1";
      this.$refs.dlgEventItems.EventSystemId=this.SystemId;
      this.$refs.dlgEventItems.showModal();
    },
    eventItemFilter(){
      this.$refs.dlgEventItems.Mode="2";
      this.$refs.dlgEventItems.EventSystemId=this.SystemId;
      this.$refs.dlgEventItems.showModal();
    },
    openGame(){
      debugger // eslint-disable-line
      window.open("/CheckInAdminGame?SystemId="+this.SystemId,"_blank");
    },
    qrCodeGen(){
      let arrMemberIds=this.getSelectRowDataSystemId();

      if (!arrMemberIds){
        return;
      }

      let loader=util.ShowLoading(this);

      apiCheckIn.api_Member_GenQRCode(arrMemberIds).then((result)=>{
        this.loadData()
        util.HideLoading(loader);

        apiCheckIn.api_Download(result.data.data);

      });
    },
    search(){
      this.loadData()
    },
    delAllMember(){
      if (!confirm('確定刪除?')){
        return;
      }
      let that=this;
      let loader=util.ShowLoading(this);

      apiCheckIn.api_Member_DeleteAll(this.SystemId).then(()=>{
        alert('刪除成功');
        that.loadData()
        util.HideLoading(loader);

      });
    },
    getSelectRowDataSystemId(){
      let selectedSystemId=this.$refs.grid.selectedItemsSystemIds();

      if (selectedSystemId.length===0){
        alert('請選擇至少一筆資料')
        return "";
      }

      return selectedSystemId;
    },
    getSelectRowData(){
      let selectedSystemId=this.$refs.grid.selectedItemsSystemIds();

      if (selectedSystemId.length===0){
        alert('請選擇至少一筆資料')
        return "";
      }

      let arrDataAll=[...this.gridDefine.datas];

      let arrAll = arrDataAll;
      let arrIn = selectedSystemId;
      let arrResult = [];

      arrResult = arrAll.filter(function(item){
        if ( arrIn.find(s=>s=== item.SystemId) ) return item;
      });

      return arrResult;
    },
    dlgEventItemsReturnAdd(items){
      let arrMemberIds=this.getSelectRowDataSystemId();

      if (!arrMemberIds){
        return;
      }

      let loader=util.ShowLoading(this);

      apiCheckIn.api_MemberJoin_Entity_Add(arrMemberIds,this.SystemId,items).then(()=>{
        this.loadData()
        util.HideLoading(loader);
      });

    },
    dlgEventItemsReturnRemove(items){
      let arrMemberIds=this.getSelectRowDataSystemId();

      if (!arrMemberIds){
        return;
      }

      let loader=util.ShowLoading(this);

      apiCheckIn.api_MemberJoin_Entity_Remove(arrMemberIds,this.SystemId,items).then(()=>{


        this.loadData()
        util.HideLoading(loader);
      });

    },

    dlgEventItemsReturnSelect(items){ // eslint-disable-line
      // let arrMemberIds=this.getSelectRowDataSystemId();
      //
      // if (!arrMemberIds){
      //   return;
      // }
      //
      // let loader=util.ShowLoading(this);
      //
      // apiCheckIn.api_MemberJoin_Entity_Remove(arrMemberIds,this.SystemId,items).then(()=>{
      //
      //
      //   this.loadData()
      //   util.HideLoading(loader);
      // });

    },

    uploadSuccess(fileUrls){
      let loader=util.ShowLoading(this);

      apiCheckIn.api_CheckInImportExcel(this.SystemId, fileUrls).then(()=>{
        this.loadData()
        util.HideLoading(loader);
      });
    },
    uploadSuccessTableNo(fileUrls){
      let loader=util.ShowLoading(this);

      apiCheckIn.api_CheckInImportExcel_TableNo(this.SystemId, fileUrls).then(()=>{
        this.loadData()
        util.HideLoading(loader);
      });
    },
  },
  mounted() {
    this.SystemId=this.$route.query.SystemId
    this.type=this.$route.query.type
    this.loadData()
  },
}
</script>

<style scoped>

</style>
